import { qs, qsa } from "../utils/dom.js"

export function initShopProductScroll() {
  const formTitle = qs("#form-title")
  if (!formTitle) return

  qsa(".product").forEach((product) => {
    product.addEventListener("click", () => {
      formTitle.scrollIntoView({ behavior: "smooth", block: "start" })
    })
  })
}
